import React from "react";
import { ReactComponent as GreySvg } from "./svg/grey-init.svg";
function InsertBtn({
  title,
  __init,
  type,
}: {
  type: string;
  title: string;
  __init: (type: string, payload: any, index: number | undefined) => void;
}) {
  return (
    <button
      className="insert-btn"
      onClick={() => {
        __init(type, "", undefined);
      }}
    >
      <GreySvg />
      {title}
    </button>
  );
}

export default InsertBtn;
